export class ActionParams {
  header: string;
}

export class ActionType {
  id: number;
  statusId: number;
  code: string;
  description: string;
  shortDescription: string;
  actionGroup: string;
  displayOrder: number;
  section: string;
}

export class ActionData {
  placementId: number;
  actionTypeId: number;
  rowId: number;
  appUserId: number;
  tutorId: number;
  section: string;
}

/** Actions search status: open (the default, and the list as it has always been), done (completed) or all. */
export type ActionStatus = 'open' | 'done' | 'all';
